import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M156.587 255.595l331.093 331.093 331.093-331.093c33.28-33.28 87.040-33.28 120.32 0s33.28 87.040 0 120.32l-391.68 391.68c-33.28 33.28-87.040 33.28-120.32 0l-391.68-391.68c-33.28-33.28-33.28-87.040 0-120.32 33.28-32.427 87.894-33.28 121.174 0z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
